@if (document.canDownload || document.inlineView) {
  <button
    pButton
    (click)="handleDocumentClick($event)"
    class="p-button-link w-full cursor-pointer"
    [ngClass]="{
      'w-full': !isLink
    }"
    [attr.aria-labelledby]="documentTitle">
    @if (!isLink) {
      <ng-container [ngTemplateOutlet]="documentContent"></ng-container>
    } @else {
      <ng-container *ngIf="isLink" [ngTemplateOutlet]="documentTitle"></ng-container>
    }
  </button>
} @else {
  <ng-container [ngTemplateOutlet]="documentContent"></ng-container>
}

<ng-template #documentTitle>
  <div class="flex items-center gap-2 overflow-hidden leading-normal">
    <i [class]="document.icon" style="width: 14px"></i>
    <span class="overflow-hidden text-ellipsis whitespace-nowrap">{{ document.name }}</span>
  </div>
</ng-template>

<ng-template #documentContent>
  <div
    class="rounded-border flex w-full items-center justify-between gap-2 overflow-hidden border border-gray-400 px-4 py-2">
    <ng-container [ngTemplateOutlet]="documentTitle"></ng-container>
    <div class="flex flex-1 items-center justify-end">
      <ng-container *ngIf="!uploadProgress && uploadProgress !== 0; else uploadActions">
        <div class="flex items-center gap-2">
          <ng-content select="[actions-before]"></ng-content>

          @if (document.canDownload) {
            <p-button
              [text]="true"
              icon="far fa-download"
              size="small"
              [title]="'common.button.download' | translate"
              (onClick)="handleDownload($event)"></p-button>
          }

          @if (canDelete()) {
            <p-button
              [text]="true"
              icon="far fa-trash-alt"
              [title]="'common.button.remove' | translate"
              size="small"
              (onClick)="handleRemoveDocument($event)"></p-button>
          }
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #uploadActions>
  <ng-container [ngSwitch]="uploadStatus">
    <ng-container *ngSwitchCase="uploadStatusses.CANCELLED">
      <i class="fa-regular fa-file-slash p-2 text-sm text-yellow-400"></i>
    </ng-container>
    <ng-container *ngSwitchCase="uploadStatusses.ERROR">
      <i class="fa-regular fa-file-xmark p-2 text-sm text-red-400"></i>
    </ng-container>
    <ng-container *ngSwitchCase="uploadStatusses.COMPLETE">
      <i class="fa-regular fa-file-check p-2 text-sm text-green-400"></i>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <p-progressBar
        [value]="uploadProgress"
        [showValue]="false"
        class="w-full"
        styleClass="relative h-4"></p-progressBar>
      <button
        pButton
        class="p-button-sm p-button-link w-min"
        icon="fa-regular fa-xmark"
        (click)="cancelUpload.emit($event)"></button>
    </ng-container>
  </ng-container>
</ng-template>
